import { LINKS } from "@silo/types";
import { DescriptionExternalLink } from "../../description";
import { KeyValueList } from "../../key-value-list";
import { DebtMetrics } from "./types";
import { BreakdownDebt } from "../../apr-display-v2/breakdown/breakdown-debt";
import { TotalApr } from "./total-apr";

interface CurrentAprProps {
  currentMetrics: DebtMetrics;
}

export function CurrentApr({ currentMetrics }: CurrentAprProps): JSX.Element {
  const { hasDebtRewards, debtBaseApr, debtRewards, isDebtAprFixed } =
    currentMetrics;

  return (
    <KeyValueList.Pair
      description={
        <div className="flex flex-col gap-2.5">
          <p>
            This is the current Annual Percentage Rate you will pay to lenders.
            The interest rate changes based on the utilization rate of the
            borrowed asset and will constantly accrue debt to your outstanding
            borrow position.
          </p>

          <DescriptionExternalLink href={LINKS.SILOPEDIA.INTEREST} />
        </div>
      }
      trailingContent={
        hasDebtRewards ? (
          <BreakdownDebt
            className="gap-0 text-sm"
            debtRewards={debtRewards}
            debtBaseApr={debtBaseApr}
            align="right"
            isDebtAprFixed={isDebtAprFixed}
          />
        ) : undefined
      }
      trailingContentContainerClassName="gap-0"
    >
      <KeyValueList.Key>Current APR</KeyValueList.Key>

      <KeyValueList.Value>
        <TotalApr metrics={currentMetrics} />
      </KeyValueList.Value>
    </KeyValueList.Pair>
  );
}
